/**
 * Fonte única de permissões: usada pelo guard do backend e para esconder ações no front.
 * Adicionar permissão = adicionar aqui + mapear nos papéis.
 */
export const PERMISSIONS = [
    'tenancy.branding.read',
    'tenancy.branding.write',
    'tenancy.domain.manage',
    'tenancy.unit.manage',
    'identity.member.manage',
    'crm.lead.read',
    'crm.lead.write',
    'inbox.conversation.read',
    'inbox.conversation.reply',
    'inbox.conversation.takeover',
    'scheduling.appointment.read',
    'scheduling.appointment.write',
    'scheduling.surgery.schedule',
    'clinical.record.read',
    'clinical.record.write',
    'clinical.record.sign',
    'clinical.photo.read',
    'billing.quote.read',
    'billing.quote.write',
    'billing.discount.approve',
    'billing.payment.read',
    'billing.payment.write',
    'billing.price.manage',
    'documents.template.manage',
    'privacy.audit.read',
    'analytics.dashboard.read',
    'ai.kb.read',
    'ai.kb.write',
    'ai.kb.approve',
    'portal.access.manage',
    'crm.settings.manage',
    'inbox.settings.manage',
    'contact.tag.apply',
    'crm.automation.manage',
    'crm.broadcast.manage',
];
const all = PERMISSIONS;
const clinicalRead = ['clinical.record.read', 'clinical.photo.read'];
export const ROLE_PERMISSIONS = {
    org_admin: new Set(all.filter((p) => !p.startsWith('clinical.') && p !== 'ai.kb.approve')),
    unit_manager: new Set([
        'tenancy.branding.read', 'tenancy.unit.manage', 'crm.lead.read', 'crm.lead.write',
        'inbox.conversation.read', 'inbox.conversation.reply', 'inbox.conversation.takeover',
        'scheduling.appointment.read', 'scheduling.appointment.write', 'scheduling.surgery.schedule',
        'billing.quote.read', 'billing.quote.write', 'billing.discount.approve', 'billing.payment.read', 'billing.payment.write', 'billing.price.manage', 'documents.template.manage',
        'analytics.dashboard.read', 'ai.kb.read', 'ai.kb.write', 'portal.access.manage',
        'crm.settings.manage', 'inbox.settings.manage', 'contact.tag.apply', 'crm.automation.manage', 'crm.broadcast.manage',
    ]),
    doctor: new Set([
        ...clinicalRead, 'clinical.record.write', 'clinical.record.sign', 'documents.template.manage',
        'inbox.conversation.read', 'inbox.conversation.reply', 'inbox.conversation.takeover',
        'scheduling.appointment.read', 'scheduling.appointment.write', 'scheduling.surgery.schedule',
        'billing.quote.read', 'billing.quote.write', 'crm.lead.read',
        'ai.kb.read', 'ai.kb.write', 'ai.kb.approve', 'contact.tag.apply',
    ]),
    nurse: new Set([
        ...clinicalRead, 'clinical.record.write',
        'inbox.conversation.read', 'inbox.conversation.reply', 'inbox.conversation.takeover',
        'scheduling.appointment.read', 'contact.tag.apply',
    ]),
    sales: new Set([
        'crm.lead.read', 'crm.lead.write', 'ai.kb.read',
        'inbox.conversation.read', 'inbox.conversation.reply', 'inbox.conversation.takeover',
        'scheduling.appointment.read', 'scheduling.appointment.write',
        'billing.quote.read', 'billing.quote.write', 'billing.payment.read', 'billing.payment.write', 'portal.access.manage', 'contact.tag.apply',
    ]),
    reception: new Set([
        'crm.lead.read', 'crm.lead.write', 'ai.kb.read', 'inbox.conversation.read', 'inbox.conversation.reply',
        'inbox.conversation.takeover', 'scheduling.appointment.read', 'scheduling.appointment.write', 'portal.access.manage', 'contact.tag.apply',
    ]),
    finance: new Set([
        'billing.quote.read', 'billing.quote.write', 'billing.payment.read', 'billing.payment.write', 'billing.price.manage',
        'analytics.dashboard.read',
    ]),
};
export function can(roles, permission) {
    return roles.some((r) => ROLE_PERMISSIONS[r].has(permission));
}
//# sourceMappingURL=permissions.js.map